import * as fromActions from '@rci/state-common-actions';
import { LoginState } from '@rci/state-service';
import { Action, createReducer, on } from '@ngrx/store';
import { Languages, Provinces } from '@rci/common';

export interface CommonState {
  language: fromActions.Language;
  province: fromActions.Province;
  userLoginState: LoginState;
}

const initialState: CommonState = {} as CommonState;

const createCommonReducer = createReducer(
  initialState,
  on(fromActions.setLanguage, (state, { language }) => ({ ...state, language: language as Languages })),
  on(fromActions.setProvince, (state, { province }) => ({ ...state, province: province as Provinces })),
  on(fromActions.setUserLoginState, (state, { loginState }) => ({ ...state, userLoginState: loginState })),
);

export const featureName = 'common';

export function commonReducer(state: CommonState, action: Action) {
  return createCommonReducer(state, action);
}
